import { useHandleTransactionRequest } from "./useHandleTransactionRequest";

/**
 * Cancels every open order on the account. The ledger action takes no payload
 * beyond its nonce, and its scope is the whole account — it is not limited to
 * one trading pair.
 */
export const useHandleCancelAllOrdersRequest = () => {
  return useHandleTransactionRequest<Record<string, never>>("CancelAllOrders");
};
